import siteVerificationStore from '@Modules/report/stores/siteVerification';
import Drilldown from 'components/drilldown/Layout';

export default class SiteVerificationDrilldown extends Drilldown {
  store = siteVerificationStore
  collection = 'Site Verification'
  report = 'site-verification'

  metrics = {
    converted: { label: 'Converted', field: 'conversiontype', value: 'converted' },
    completed: { label: 'Completed', field: 'registration_completed', value: true },
    total: { label: 'Total' },
  }

  fields = {
    default: ['id', 'cmsVerificationsSiteId', 'cmsVerificationsId', 'userSessionId', 'userId', 'cost', 'verificationType', 'createdAt'],
    options: [
      { group: 'General', value: 'id', label: 'Verification Id' },
      { group: 'General', value: 'cmsVerificationsSiteId', label: 'Site Verification Id' },
      { group: 'General', value: 'cmsVerificationsId', label: 'Verification Type Id' },
      { group: 'General', value: 'cost', label: 'Cost' },
      { group: 'General', value: 'verificationType', label: 'Verification Type' },
      { group: 'General', value: 'createdAt', label: 'Created At' },
      { group: 'General', value: 'updatedAt', label: 'Updated At' },
      { group: 'General', value: 'organizationId', label: 'Organization Id' },
      { group: 'General', value: 'siteId', label: 'Site Id' },

      { group: 'Traffic', value: 'allocationId', label: 'Allocation Id' },
      { group: 'Traffic', value: 'publisherId', label: 'Publisher Id' },
      { group: 'Traffic', value: 'sid1', label: 'SubID 1' },
      { group: 'Traffic', value: 'sid2', label: 'SubID 2' },
      { group: 'Traffic', value: 'sid3', label: 'SubID 3' },
      { group: 'Traffic', value: 'payouttype', label: 'Payout Type' },
      { group: 'Traffic', value: 'converted', label: 'Converted' },
      { group: 'Traffic', value: 'registrationCompleted', label: 'Registration Completed' },
      { group: 'Traffic', value: 'conversiontype', label: 'Conversion Type' },
      { group: 'Traffic', value: 'externalId', label: 'External Id' },
      { group: 'Traffic', value: 'campaignId', label: 'Campaign Id' },

      { group: 'User', value: 'userId', label: 'Id' },
      { group: 'User', value: 'userCreatedAt', label: 'Created At' },
      { group: 'User', value: 'userUpdatedAt', label: 'Updated At' },
      { group: 'User', value: 'userFirstName', label: 'First Name' },
      { group: 'User', value: 'userLastName', label: 'Last Name' },
      { group: 'User', value: 'userEmail', label: 'Email' },
      { group: 'User', value: 'userEmailDomain', label: 'Email Domain' },
      { group: 'User', value: 'userAddress1', label: 'Address 1' },
      { group: 'User', value: 'userAddress2', label: 'Address 2' },
      { group: 'User', value: 'userCity', label: 'City' },
      { group: 'User', value: 'userState', label: 'State' },
      { group: 'User', value: 'userZip', label: 'Zip' },
      { group: 'User', value: 'userCountry', label: 'Country' },
      { group: 'User', value: 'userPhone', label: 'Phone' },
      { group: 'User', value: 'userDob', label: 'Date of Birth' },
      { group: 'User', value: 'userAge', label: 'Age' },
      { group: 'User', value: 'userGender', label: 'Gender' },
      { group: 'User', value: 'userUnsubscribed', label: 'Unsubscribed' },
      { group: 'User', value: 'userValidated', label: 'Validated' },

      { group: "Session", value: "userSessionId", label: "Id" },
      { group: "Session", value: "userSessionCreatedAt", label: "Created At" },
      { group: "Session", value: "userSessionUpdatedAt", label: "Updated At" },
      { group: "Session", value: "userSessionFormId", label: "Form Id" },
      { group: "Session", value: "userSessionOfferId", label: "Offer Id" },
      { group: "Session", value: "userSessionPathId", label: "Path Id" },
      { group: "Session", value: "userSessionPostId", label: "Post Id" },
      { group: "Session", value: "userSessionPostTargetId", label: "Post Target Id" },
      { group: "Session", value: "userSessionPostVersionId", label: "Post Version Id" },
      { group: "Session", value: "userSessionSlotPosition", label: "Slot Position" },
      { group: "Session", value: "userSessionTcpaConsent", label: "TCPA Consent" },
      { group: "Session", value: "userSessionRegistrationConsent", label: "Registration Consent" },
      { group: "Session", value: "userSessionRecordingConsent", label: "Recording Consent" },
      { group: "Session", value: "userSessionBrowserAgent", label: "Browser Agent" },
      { group: "Session", value: "userSessionReferrer", label: "Referrer" },
      { group: "Session", value: "userSessionOriginalUrl", label: "Url" },
      { group: "Session", value: "userSessionIpAddress", label: "Ip" },
      { group: "Session", value: "userSessionDevice", label: "Device" },
      { group: "Session", value: "userSessionOS", label: "OS" },
      { group: "Session", value: "userSessionBrowser", label: "Browser" },
      { group: "Session", value: "userSessionTrustedFormCert", label: "Trusted Form" },
      { group: "Session", value: "userSessionLeadidCert", label: "Lead Id" },
      { group: "Session", value: "userSessionRegistrationTotalStep", label: "Registration Total Step" },
      { group: "Session", value: "userSessionRegistrationStep", label: "Registration Step" },
      { group: "Session", value: "userSessionDuplicated", label: "Session Duplicated" },
      { group: "Session", value: "userSessionSkipRegistration", label: "Skip Registration" },
      { group: "Session", value: "userSessionEmailVerification", label: "Email Verification" },
      { group: "Session", value: "userSessionAddressVerification", label: "Address Verification" },
      { group: "Session", value: "userSessionBotVerification", label: "Bot Verification" },
      { group: "Session", value: "userSessionFraudVerification", label: "Fraud Verification" },
      { group: "Session", value: "userSessionFraudScore", label: "Fraud Score" },
      { group: "Session", value: "userSessionHook", label: "Hook" },
      { group: "Session", value: "userSessionOptout", label: "Optout" },
      { group: "Session", value: "userSessionPhoneVerification", label: "Phone Verification" },
      { group: "Session", value: "userSessionPostalVerification", label: "Postal Verification" },
      { group: "Session", value: "userSessionIpCity", label: "Ip City" },
      { group: "Session", value: "userSessionIpState", label: "Ip State" },
      { group: "Session", value: "userSessionIpZip", label: "Ip Zip" },
      { group: "Session", value: "userSessionRevenue", label: "Revenue" },
    ],
  }
}
